// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2u9nB","sendOtp":"AuthorizeToLogin_sendOtp__3S3rO"};